interface SidePanelFooterProps {
  children: React.ReactNode;
}
export default function SidePanelFooter({ children }: SidePanelFooterProps) {
  return (
    <div className="flex-none p-4 border-t border-gray-300">{children}</div>
  );
}
